import { render, staticRenderFns } from "./draw-reg-modal.vue?vue&type=template&id=297750d7&scoped=true&"
import script from "./draw-reg-modal.vue?vue&type=script&lang=js&"
export * from "./draw-reg-modal.vue?vue&type=script&lang=js&"
import style0 from "./draw-reg-modal.vue?vue&type=style&index=0&id=297750d7&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "297750d7",
  null
  
)

export default component.exports